import * as React from 'react';
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import { FormControlLabel, Typography, useTheme } from '@mui/material';
import { appInsights } from '../../../auth/appInsight';
import { devConsoleLog, getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';

const FormControl = styled(FormControlLabel)(({ theme }) => ({}));

const Text = styled('span')(({ theme, checkboxcolortext, fontsize, smfontsize, lineheight, fontweight, textalign }) => ({
  fontFamily: 'Poppins!important',
  fontStyle: 'normal',
  fontWeight: fontweight || '400',
  fontSize: fontsize || '16px',
  lineHeight: lineheight || 'normal',
  textAlign: textalign,
  color: checkboxcolortext || theme.palette.text.secondary,
  [theme.breakpoints.down('sm')]: {
    fontSize: smfontsize ? `${smfontsize}px !important` : '9px !important'
  },
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, fontsize || '16px'),
    lineHeight: getStringProduct(1.25, lineheight || 'normal')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, fontsize || '16px'),
    lineHeight: getStringProduct(1.66, lineheight || 'normal')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, fontsize || '16px'),
    lineHeight: getStringProduct(2.46, lineheight || 'normal')
  }
  // ...rest
}));

const BpIcon = styled('span')(({ theme, checkboxcolor = '' }) => ({
  borderRadius: 5,
  width: 17,
  height: 17,
  padding: '2px',
  border: `2px solid ${checkboxcolor || theme.palette.border.border}`,
  backgroundColor: 'transparent',
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)'
  },
  [theme.breakpoints.up('xll')]: {
    borderRadius: getStringProduct(1.25, 5),
    width: getStringProduct(1.25, 17),
    height: getStringProduct(1.25, 17),
    padding: getStringProduct(1.25, '2px'),
    border: getDynamicBorder(1.25, `2px solid ${checkboxcolor || theme.palette.border.border}`)
  },
  [theme.breakpoints.up('xlll')]: {
    borderRadius: getStringProduct(1.66, 5),
    width: getStringProduct(1.66, 17),
    height: getStringProduct(1.66, 17),
    padding: getStringProduct(1.66, '2px'),
    border: getDynamicBorder(1.66, `2px solid ${checkboxcolor || theme.palette.border.border}`)
  },
  [theme.breakpoints.up('xl4')]: {
    borderRadius: getStringProduct(2.46, 5),
    width: getStringProduct(2.46, 17),
    height: getStringProduct(2.46, 17),
    padding: getStringProduct(2.46, '2px'),
    border: getDynamicBorder(2.46, `2px solid ${checkboxcolor || theme.palette.border.border}`)
  }
}));

const BpCheckedIcon = styled(BpIcon)(({ theme, checkboxcolor = '' }) => ({
  backgroundColor: 'transparent',
  '&:before': {
    display: 'block',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    borderRadius: 3,
    backgroundColor: checkboxcolor || theme.palette.border.border,
    content: '""'
  },
  [theme.breakpoints.up('xll')]: {
    '&:before': {
      borderRadius: getStringProduct(1.25, 3)
    }
  },
  [theme.breakpoints.up('xlll')]: {
    '&:before': {
      borderRadius: getStringProduct(1.66, 3)
    }
  },
  [theme.breakpoints.up('xl4')]: {
    '&:before': {
      borderRadius: getStringProduct(2.46, 3)
    }
  }
}));

// function BpCheckbox(props) {
//   const { label, checkboxcolor, handleChange, checked, margintop, ...rest } = props;
//   return (
//     <FormControl
//       onChange={handleChange}
//       checked={checked}
//       sx={{ alignItems: 'flex-start' }}
//       control={
//         <Checkbox
//           sx={{
//             marginTop: margintop || '-1px',
//             '&:hover': { bgcolor: 'transparent' }
//           }}
//           {...props}
//           disableRipple
//           color="default"
//           checkedIcon={<BpCheckedIcon checkboxcolor={checkboxcolor} />}
//           icon={<BpIcon checkboxcolor={checkboxcolor} />}
//           inputProps={{ 'aria-label': 'Checkbox demo' }}
//         />
//       }
//       label={
//         <Text {...props} variant="caption">
//           {label}
//         </Text>
//       }
//     />
//   );
// }

export default function FreedomCheckbox1(props) {
  const theme = useTheme();
  try {
    const { label, checkboxcolor, handlechange, checked, margintop, fontsize, checkboxpadding, alignitems = 'flex-start', ...rest } = props;

    devConsoleLog('rest operator', { ...rest });

    // Determine if the label is a string or a component
    const renderLabel = () => {
      if (typeof label === 'string') {
        return (
          <Text fontsize={fontsize} {...rest} variant="caption">
            {label}
          </Text>
        );
      }
      // If it's a React component/element, return it directly
      return label;
    };

    return (
      <FormControlLabel
        onChange={handlechange}
        checked={checked}
        sx={{ alignItems: alignitems, lineHeight: 'normal', [theme.breakpoints.down('sm')]: { alignItems: 'flex-start' } }}
        control={
          <Checkbox
            sx={{
              marginTop: margintop || '-1px',
              '&:hover': { bgcolor: 'transparent' },
              padding: checkboxpadding || '6px',
              [theme.breakpoints.up('xll')]: {
                marginTop: getStringProduct(1.25, margintop || '-1px'),
                padding: getStringProduct(1.25, checkboxpadding || '6px')
              },
              [theme.breakpoints.up('xlll')]: {
                marginTop: getStringProduct(1.66, margintop || '-1px'),
                padding: getStringProduct(1.66, checkboxpadding || '6px')
              },
              [theme.breakpoints.up('xl4')]: {
                marginTop: getStringProduct(2.46, margintop || '-1px'),
                padding: getStringProduct(2.46, checkboxpadding || '6px')
              }
            }}
            {...rest}
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon checkboxcolor={checkboxcolor} />}
            icon={<BpIcon checkboxcolor={checkboxcolor} />}
            inputProps={{ 'aria-label': 'Checkbox demo' }}
          />
        }
        label={renderLabel()}
      />
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
}
